import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, Button, IconButton, Box } from "@material-ui/core";
import FileUpload from "components/FileUpload/FileUpload";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import ConfirmationModal from "views/components/ConfirmationModal";
import { parseAndSetFlag } from "utils/Utils";
import {
  packetSizesOptions,
  fullSourceOfOwnershipOptions,
  simplifiedSourceOfOwnershipOptions,
} from "assets/properties/properties";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import BottomButton from "components/CustomButtons/BottomButton";
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { validateCurrentRow } from "../OrnamentValidation";
const OrnamentTable = ({
  editable,
  handleChange,
  lastIndex,
  groupDetails,
  updateOrnamentDetails,
  ornamentList,
  handleOrnamentValue,
  handleStoneWeight,
  handleOrnamentCount,
  ornamentValues,
  handleDeductionUpdate,
  getOrnamentData,
  classes,
  showUpload,
  setShowUpload,
  featureFlag,
  isOrnamentAudited,
  checkForAuditedFlagOrnamentFlag,
  userDetails,
  showDeleteButton,
  enabelPacketNumber,
  closeModal,
  addNextRow,
  setGroupDetails,
  setLastIndex,
  editIndex,
  editIndexData,
  groupDetailsOriginal,
  enabledValidationForRepledgeOrnament,
  toastUpdate,
  enabledSamePacketNumberOrnamentCheck,
  loanType,
  enabledLeadValidateForNewLoan,
  minNetWeightValue,
  featureFlags,
  subStatus,
  disableExistingOrnamentFields,
  blurCompletedRef
}) => {
  const [showCamera, setShowCamera] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [selectedEvent, setSelectedEvent] = useState({});
  const [selectedIndex, setSelectedIndex] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoverName, setHoverName] = useState(null);
  const packetSizeList = featureFlags?.packetSizesList ? JSON.parse(featureFlags?.packetSizesList) : [];
  const showPopUpForSelectAnotherPacketFlag = parseAndSetFlag(featureFlags?.showPopUpForSelectAnotherPacketFlag);
  const removeSourceOfOwnership = parseAndSetFlag(featureFlags?.removeSourceOfOwnershipFlag);
  const financeCodeListFlag = featureFlags?.financeCodeListFlag ? JSON.parse(featureFlags?.financeCodeListFlag) : [];
  const sourceData = !removeSourceOfOwnership ? fullSourceOfOwnershipOptions : simplifiedSourceOfOwnershipOptions;
  const handleTakePhoto = async (dataUri, type, index) => {
    const blob = await fetch(dataUri).then((res) => res.blob());
    handleChange(blob, index, "ornamentPhotoLink", type);
    setShowCamera(false);
  };

  const onClickCamera = () => {
    setShowCamera(true);
    setShowUpload(false);
  };

  const proceedPacketNumber = (data, index) => {
    setSelectedEvent(data);
    setSelectedIndex(index);
    setConfirmationModalHeader("Ornament Details");
    setConfirmationModalMsg("Do you want to add another packet in loan");
    setConfirmationModal(true);
  };

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
  };

  const handlePositiveResponse = () => {
    handleNegativeResponse();
    handleChange(selectedEvent, selectedIndex);
  };
  const currentIndex =
  editIndex !== undefined && editIndex !== null && editIndex !== '' ? editIndex : lastIndex;
  let isAuditFlagTrue = false;
  let isHoType = false;
  if (checkForAuditedFlagOrnamentFlag) {
    if (userDetails?.rootHierarchy) {
      isAuditFlagTrue = false;
      isHoType = true;
    } else {
      isAuditFlagTrue = true;
      isHoType = false;
    }
  }
  // ✅ Simplified actions
  const handleSave = () => {
  const currentRow = groupDetails?.[currentIndex];

  if (currentRow) {
    const netWeight = Number(currentRow?.netWeight || 0);
    const netWeight22k = Number(currentRow?.netWeightWith22k || 0);
    const finesseValue = parseInt(currentRow?.finnesseCode, 10);
    if (finesseValue <= 22 && netWeight < netWeight22k) {
      toastUpdate(
        "Error",
        `Net weight (${netWeight}) cannot be less than 22K Eq. Net weight (${netWeight22k}).`,
        true
      );
      return;
    }
  }
  if(!validateCurrentRow(groupDetails, currentIndex, enabledLeadValidateForNewLoan, minNetWeightValue, checkValidationForNewPacket, toastUpdate)) return;
  if(enabledValidationForRepledgeOrnament){
    if(currentRow){
    const netWeight = Number(currentRow?.netWeight || 0);
    const originalNetWeight = Number(groupDetailsOriginal?.[currentIndex]?.netWeight);
    if (netWeight > originalNetWeight) {
      toastUpdate(
        "Error",
        `Net weight (${netWeight}) cannot be more than original Net weight (${originalNetWeight}).`,
        true
      );
      return;
    }
    }
  }
  let updatedList = [...groupDetails];
  if(enabledSamePacketNumberOrnamentCheck && loanType === "RE_PLEDGE" && currentIndex === 0){
    const updated = groupDetails?.map((item) => ({
      ...item,
      packetNumber: currentRow?.packetNumber,
      packetSize: currentRow?.packetSize,
      packetWeight: currentRow?.packetWeight,
      packetSealed: currentRow?.packetSealed,
      packetSealNumber: currentRow?.packetSealNumber,
      availablePacketNumber: currentRow?.availablePacketNumber,
    }));
    updatedList = updated;
  }
  setGroupDetails(updatedList);
  closeModal(updatedList);
};

const handleSaveAndAddMore = () => {
  const currentRow = groupDetails?.[currentIndex];

  if (currentRow) {
    const netWeight = Number(currentRow?.netWeight || 0);
    const netWeight22k = Number(currentRow?.netWeightWith22k || 0);
    const finesseValue = parseInt(currentRow?.finnesseCode, 10);

    if (finesseValue <= 22 && netWeight < netWeight22k) {
      toastUpdate(
        "Error",
        `Net weight (${netWeight}) cannot be less than 22K Eq. Net weight (${netWeight22k}).`,
        true
      );
      return;
    }
  }
  if(!validateCurrentRow(groupDetails, currentIndex, enabledLeadValidateForNewLoan, minNetWeightValue, checkValidationForNewPacket, toastUpdate)) return;
  if(enabledValidationForRepledgeOrnament){
    if(currentRow){
    const netWeight = Number(currentRow?.netWeight || 0);
    const originalNetWeight = Number(groupDetailsOriginal?.[currentIndex]?.netWeight);
    if (netWeight > originalNetWeight) {
      toastUpdate(
        "Error",
        `Net weight (${netWeight}) cannot be more than Original Net weight (${originalNetWeight}).`,
        true
      );
      return;
    }
    }
  }

  if (addNextRow) addNextRow(groupDetails);
};


  const handleCancel = () => {
    let updatedList = [...groupDetails];
    if(editIndex !== undefined && editIndex !== null && editIndex !== ''){
     updatedList[editIndex] = editIndexData;
    }else{
    setLastIndex(lastIndex - 1);
    updatedList = groupDetails.filter((_, i) => i !== lastIndex);
  }
    setGroupDetails(updatedList);
    closeModal(updatedList);
  };

  const validateRow = (row) => {
    if (!row) return false;

    // Add all required fields here
    const requiredFields = [
      "particulars",
      "finnesseCode",
      "itemCount",
      "grossWeight",
      "stoneWeight",
      "deduction",
      "sourceOfOwnership",
    ];

    // If packetNumber and packetSize are enabled, include them in validation
    if (
      enabelPacketNumber !== 0 ||
      (enabelPacketNumber === 0 && currentIndex === 0)
    ) {
      requiredFields.push("packetSize", "packetNumber","packetSealNumber");
    }

    // Check if all required fields have value
    return requiredFields.every((field) => {
      const value = row[field];
      return value !== undefined && value !== null && value !== "";
    });
  };
  
  const isRowValid = validateRow(groupDetails?.[currentIndex]);
const checkValidationForNewPacket = (index, passingValue = "") => {
  const validatedOrnament = groupDetails?.[index]?.additionalInfo?.disableExistingFields;
    if(disableExistingOrnamentFields){
      if (subStatus !== "PART_RELEASE") {
        return validatedOrnament;
      }else if (passingValue !== "") {
        return validatedOrnament;
      }else {
      return false;
      }
    }else{
      validatedOrnament
    }
  };
   return (
    <div>
      {groupDetails?.[currentIndex] && (
        <Grid
          container
          spacing={2}
          key={currentIndex}
          className={classes.inputContainer}
        >
          {/* Particulars */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Particulars*"
              value={groupDetails?.[currentIndex]?.particulars || ""}
              setState={(value) =>
                handleChange(
                  { target: { value, name: "particulars" } },
                  currentIndex
                )
              }
              data={ornamentList.map((orn) => orn.name)}
              disabled={
                (isAuditFlagTrue
                  ? groupDetails?.[currentIndex]?.isOrnamentAudited
                  : checkValidationForNewPacket(currentIndex, 'disabled'))
              }
            />
          </Grid>

          {/* Fineness Code */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Purity*"
              value={groupDetails?.[currentIndex]?.finnesseCode || ""}
              setState={(value) =>
                handleChange(
                  { target: { value, name: "finnesseCode" } },
                  currentIndex
                )
              }
              data={financeCodeListFlag}
              disabled={
                groupDetails?.[currentIndex]?.disabledField ||
                (isAuditFlagTrue
                  ? groupDetails?.[currentIndex]?.isOrnamentAudited
                  : checkValidationForNewPacket(currentIndex, 'disabled'))
              }
            />
          </Grid>

          {/* Count */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <div
              onMouseEnter={() => {
                setHoveredIndex(currentIndex);
                setHoverName("count");
              }}
              onMouseLeave={() => {
                setHoveredIndex(null);
                setHoverName(null);
              }}
              style={{ position: "relative" }}
            >
              <CustomTextField
                label="Count*"
                name="itemCount"
                value={groupDetails?.[currentIndex]?.itemCount || ""}
                disabled={
                  groupDetails?.[currentIndex]?.disabledField ||
                  (isAuditFlagTrue
                    ? groupDetails?.[currentIndex]?.isOrnamentAudited
                    : checkValidationForNewPacket(currentIndex))
                }
                setState={(value) =>
                  handleChange(
                    { target: { name: "itemCount", value } },
                    currentIndex
                  )
                }
                setIndexBlur={handleOrnamentCount} // pass function directly
                index={currentIndex}
              />
              {hoveredIndex === currentIndex &&
                hoverName === "count" &&
                (ornamentValues?.[currentIndex]?.count ||
                  ornamentValues?.[currentIndex]?.maxGrossWeight) && (
                  <div
                    className={classes.countValue}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#f0f0f0",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      display: "flex",
                      gap: "8px",
                    }}
                  >
                    <span>{`min 1`}</span>
                    <span>{`max ${
                      ornamentValues?.[currentIndex]?.count ||
                      ornamentValues?.[currentIndex]?.maxAllowedCount
                    }`}</span>
                  </div>
                )}
            </div>
          </Grid>

          {/* Gross Weight */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <div
              onMouseEnter={() => {
                setHoveredIndex(currentIndex);
                setHoverName("weight");
              }}
              onMouseLeave={() => {
                setHoveredIndex(null);
                setHoverName(null);
              }}
              style={{ position: "relative" }}
            >
              <CustomTextField
                label="Gross Wt* (Gm)"
                value={groupDetails?.[currentIndex]?.grossWeight || ""}
                disabled={
                  groupDetails?.[currentIndex]?.disabledField ||
                  (isAuditFlagTrue
                    ? groupDetails?.[currentIndex]?.isOrnamentAudited
                    : checkValidationForNewPacket(currentIndex))
                }
                setState={(value) =>
                  handleChange(
                    { target: { name: "grossWeight", value } },
                    currentIndex
                  )
                }
                setIndexBlur={handleOrnamentValue}
                index={currentIndex}
              />
              {hoveredIndex === currentIndex &&
                hoverName === "weight" &&
                (ornamentValues?.[currentIndex]?.minGrossWeight ||
                  ornamentValues?.[currentIndex]?.maxGrossWeight) && (
                  <div
                    className={classes.countValue}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#f0f0f0",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      display: "flex",
                      gap: "8px",
                    }}
                  >
                    <span>{`min ${
                      (ornamentValues?.[currentIndex]?.minGrossWeight || 0) *
                      (Number(groupDetails?.[currentIndex]?.itemCount) || 1)
                    }`}</span>
                    <span>{`max ${
                      (ornamentValues?.[currentIndex]?.maxGrossWeight || 0) *
                      (Number(groupDetails?.[currentIndex]?.itemCount) || 1)
                    }`}</span>
                  </div>
                )}
            </div>
          </Grid>

          {/* Stone Weight */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Stone Wt* (Gm)"
              value={groupDetails?.[currentIndex]?.stoneWeight || ""}
              disabled={
                groupDetails?.[currentIndex]?.disabledField ||
                (isAuditFlagTrue
                  ? groupDetails?.[currentIndex]?.isOrnamentAudited
                  : checkValidationForNewPacket(currentIndex))
              }
              setState={(value) =>
                handleChange(
                  { target: { name: "stoneWeight", value } },
                  currentIndex
                )
              }
              setIndexBlur={handleStoneWeight}
              index={currentIndex}
            />
          </Grid>

          {/* Deduction */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Deduction*"
              value={groupDetails?.[currentIndex]?.deduction || ""}
              disabled={
                groupDetails?.[currentIndex]?.disabledField ||
                (isAuditFlagTrue
                  ? groupDetails?.[currentIndex]?.isOrnamentAudited
                  : checkValidationForNewPacket(currentIndex))
              }
              setState={(value) =>
                handleChange(
                  { target: { name: "deduction", value } },
                  currentIndex
                )
              }
              setIndexBlur={handleDeductionUpdate}
              index={currentIndex}
            />
          </Grid>
          {/* Net Weight */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Net Wt* (Gm)"
              name="netWeight"
              value={groupDetails?.[currentIndex]?.netWeight || ""}
              disabled
            />
          </Grid>

          {/* 22K Equivalent Net Weight */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="22K Eq. Net Wt*(Gm)"
              name="22kequivalentWeight"
              value={groupDetails?.[currentIndex]?.netWeightWith22k || ""}
              disabled
            />
          </Grid>

          {/* Source of Ownership */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Source Of Own*"
              value={groupDetails?.[currentIndex]?.sourceOfOwnership || ""}
              setState={(value) =>
                handleChange(
                  { target: { value, name: "sourceOfOwnership" } },
                  currentIndex
                )
              }
              data={sourceData}
              disabled={groupDetails?.[currentIndex]?.disabledField || checkValidationForNewPacket(currentIndex)}
            />
          </Grid>
          {/* Packet Size, Number, Seal Number */}
          {enabelPacketNumber !== 0 ||
          (enabelPacketNumber === 0 && currentIndex === 0) ? (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomSelectNew
                  label="Packet Size*"
                  value={groupDetails?.[currentIndex]?.packetSize || ""}
                  setState={(value) =>
                    handleChange(
                      { target: { value, name: "packetSize" } },
                      currentIndex
                    )
                  }
                  data={packetSizeList}
                  disabled={
                    groupDetails?.[currentIndex]?.disabledField || isHoType
                  }
                  type="type"
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                {getOrnamentData ? (
                  <CustomTextField
                    label="Pkt Num*"
                    value={groupDetails?.[currentIndex]?.packetNumber || ""}
                    disabled
                  />
                ) : (
                  <CustomSelectNew
                    label="Pkt Num*"
                    value={groupDetails?.[currentIndex]?.packetNumber || ""}
                    setState={(value) => {
                      const event = { target: { value, name: "packetNumber" } };
                      if (
                        groupDetails?.[0]?.packetNumber &&
                        showPopUpForSelectAnotherPacketFlag
                      ) {
                        proceedPacketNumber(event, currentIndex);
                      } else {
                        handleChange(event, currentIndex);
                      }
                    }}
                    data={groupDetails?.[currentIndex]?.availablePacketNumber || []}
                    disabled={
                      groupDetails?.[currentIndex]?.disabledField || isHoType
                    }
                    type="packetNumber"
                  />
                )}
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomSelectNew
                  label="Seal Num*"
                  value={groupDetails?.[currentIndex]?.packetSealNumber || ""}
                  setState={(value) =>
                    handleChange(
                      { target: { value, name: "packetSealNumber" } },
                      currentIndex
                    )
                  }
                  data={["1", "2", "3"]}
                  disabled={groupDetails?.[currentIndex]?.disabledField}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "black",
                  // gap: "20px",
                  fontSize: "16x",
                }}
              >
                {" "}
                <input
                  style={{ marginTop: 2, width: "30px", height: "30px",marginRight:'5px' }}
                  id="select_all"
                  type="checkbox"
                  name="packetSealed"
                  checked={groupDetails?.[currentIndex]?.packetSealed}
                  className={classes.checkboxInput}
                  onChange={(e) => handleChange(e, currentIndex)}
                />{" "}
                Packet Sealed
              </label>
            </Grid>
            </>
          ) : null}
          <Grid item xs={12} sm={6} md={enabelPacketNumber !== 0 ||
          (enabelPacketNumber === 0 && currentIndex === 0) ? 4 : 8}>
            {showCamera && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0,0,0,0.8)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Camera
                  onTakePhoto={(dataUri) =>
                    handleTakePhoto(dataUri, "CUSTOMER", currentIndex)
                  }
                  isMaxResolution
                />
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginTop: 16 }}
                  onClick={() => setShowCamera(false)}
                >
                  Close Camera
                </Button>
              </div>
            )}
          </Grid>
          {/* Camera & File Upload */}
          <Grid item xs={12} sm={6} md={4} className={classes.cameraContainer} style={{display:'flex', height:'auto',justifyContent:groupDetails?.[currentIndex]?.ornamentPhotoLink  ?'center' : 'right', alignItems:'center', gap:'10px'}}>
            {!groupDetails?.[currentIndex]?.ornamentPhotoLink ? (
              <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  border: "1px solid #d0d0d0",
                  borderRadius: "10px",
                  padding: "-5px 44px",
                  backgroundColor: "#f9f9f9",
                  width: enabelPacketNumber !== 0 || (enabelPacketNumber === 0 && currentIndex === 0) ? "80%" : "80%",
                  marginRight:'20px',
                  justifyContent:'center',
                }}
              >
                <IconButton
                onClick={() => onClickCamera()}
                style={{
                  color: "blue",
                  marginRight: "8px",
                  height:'65%'
                }}
                // className={localClasses.nextButton1}
              >
                <CameraAltIcon />
              </IconButton>
                {showUpload && (
                  <FileUpload
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                    ]}
                    addButtonProps={{ color: "info", round: false }}
                    removeButtonProps={{ round: false }}
                    sendFile={(file) =>
                      handleChange(file, currentIndex, "ornamentPhotoLink")
                    }
                    name="Upload Image"
                    classes={classes}
                    removeButton
                    icon
                  />
                )}
                </Box>
              </>
            ) : (
              <Grid style={{display:'flex', flexDirection:"column", alignItems:'center'}}>
              <span style={{fontSize:'12px'}}>Ornament Photo</span>
               {groupDetails?.[currentIndex]?.ornamentPhotoLink !== "" && (
                   <img src={groupDetails?.[currentIndex]?.ornamentPhotoLink} width="100" height="100" alt="ornamnetImage"/>
                )}
              <Button
                style={{
                  // background: brandTheme.labelColor,
                  color: "blue",
                  width: enabelPacketNumber !== 0 || (enabelPacketNumber === 0 && currentIndex === 0) ? "80%" : "80%",
                  marginRight:'20px',
                  height:'40px',
                  textDecoration:'underline',
                  textTransform:'capitalize'

                }}
                onClick={() => handleChange("remove", currentIndex)}
              >
                Remove
              </Button>
              </Grid>
            )}
          </Grid>

          {/* Bottom Buttons */}
          <Grid item xs={12} className={classes.ButtomButtonContainer}>
            <BottomButton
              button1="Save"
              button2={editIndex !== undefined && editIndex !== null && editIndex !== '' ? '' : "Save & Add more"}
              button3="Cancel"
              button1click={handleSave}
              button2click={handleSaveAndAddMore}
              button3click={handleCancel}
              disabled1={!isRowValid || blurCompletedRef.current}
              disabled2={!isRowValid || blurCompletedRef.current}
              center
            />
          </Grid>
        </Grid>
      )}

      {/* Confirmation Modal */}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
          classes={classes}
          positiveButtonText="Yes"
          negativeButtonText="No"
        />
      )}
    </div>
  );
};

OrnamentTable.propTypes = {
  classes: PropTypes.object,
  editable: PropTypes.bool,
};

export default OrnamentTable;
